import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { resetOrderSession } from '../utils/resetOrderSession';
import useCart from '../hooks/useCart';

export default function useNavigationGuard(shouldBlock) {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [nextLocation, setNextLocation] = useState(null);
  const { resetCart } = useCart(undefined, null, { skipInitialFetch: true });

  const guardedNavigate = (to, options = {}) => {
    if (shouldBlock) {
      setShowModal(true);
      setNextLocation({ to, options });
    } else {
      navigate(to, options);
    }
  };

  const confirmNavigation = () => {
    setShowModal(false);

      // Clear current order session
      resetOrderSession();
      resetCart();

    if (nextLocation?.isBack) {
      window.history.back();
    } else if (nextLocation) {
      navigate(nextLocation.to, nextLocation.options);
    }

    setNextLocation(null);
  };

  const cancelNavigation = () => {
    setShowModal(false);
    setNextLocation(null);

    // ye hum restore state so back stays blocked
    window.history.pushState({ guarded: true }, '');
  };

  // Handle browser back karo tum
  useEffect(() => {
    if (!shouldBlock) return;

    const handlePopState = (e) => {
      e.preventDefault();
      setShowModal(true);
      setNextLocation({ isBack: true });
    };

    window.history.pushState({ guarded: true }, '');
    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [shouldBlock]);

  //  Handle refresh / tab close karo ise 
  useEffect(() => {
    if (!shouldBlock) return;

    const handleBeforeUnload = (e) => {
      e.preventDefault();
      e.returnValue = '';
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [shouldBlock]);

  return {
    showModal,
    confirmNavigation,
    cancelNavigation,
    guardedNavigate,
  };
}